import React from 'react';
import RoleAnalyticsDashboard from './RoleAnalyticsDashboard';

const AdministratorDashboard = () => {
  return <RoleAnalyticsDashboard roleLabel="Administrator Dashboard" />;
};

export default AdministratorDashboard;